import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loaders: 0,
        specPropsOptions: [],           // 可选规格

        firstSpecVal: {},               // 设规格筛选值
        secondSpecVal: {},              // 设规格筛选值
        thirdSpecVal: {},               // 设规格筛选值

        containsWares: [],               // 商品已配置的配件列表
        wareOptions: [],                  // 可配置的配件列表

        isShowNavSetting: true,          // 是否显示上方设置导航栏

    },
    mutations: {
        setSettingNav(state, val) {
            state.isShowNavSetting = val;
        },
        setLoaders(state, val) {
            state.loaders = val;
        },

    },
    actions: {
    },
    modules: {
    }
})
